module.exports = __webpack_public_path__ + "static/media/ppc-primary.b7e46f62.svg";